import { Col, Row } from 'antd';
import React, { useState } from 'react';
import '@ant-design/compatible/assets/index.css';
import { findObjIntoArrayByProp, formatMoney } from '@iso/lib/helpers/utility';

import ordersApi from '@iso/services/repository/order';
import paymentFormApi from '@iso/services/repository/comercialCondition/paymentForm';

export default function ListPaymentForms(props) {

    const [payments, setPayments] = useState([]);

    React.useEffect(async () => {
        getPaymentForms()
    }, []);
    
    const getPaymentForms = () => {
        paymentFormApi.getAllSimple().then(r => {
            getOrdersFromCashBox(props.id, r.data)
        })
    }

    const getOrdersFromCashBox = (id, auxPaymentForms) => {
        ordersApi.getOrdersFromCashBox({cashboxId: id}).then(r => {
            iterateRecords(r.data, auxPaymentForms);
        })
    }

    const iterateRecords = (data, auxPaymentForms) => {

        let pIdx;
        let pName = '';
        let changeValue = 0;
        let auxPayments = {};

        try {
            // PRIMEIRO ITERAR SOBRE PAGAMENTOS RECEBIDOS

            data.forEach(element => { 
                if(element?.venda) {
                    if(element.venda?.payment) {

                        changeValue += element.venda.payment.change;

                        element.venda.payment.methods.forEach(payment => {
                            if(typeof auxPayments[payment.form] === 'undefined') {

                                pIdx = findObjIntoArrayByProp(auxPaymentForms, '_id', payment.form);

                                pName = (pIdx !== -1) ? auxPaymentForms[pIdx]['name'] :  'Forma não identificada';

                                auxPayments[payment.form] = {
                                    amount:0,
                                    name: pName,
                                    key: payment.form
                                }
                            }

                            auxPayments[payment.form]['amount'] += payment.value;
                        });
                    }
                }
            });

            // AGORA EXIBIR AS DEMAIS FORMAS DE PAGAMENTO.

            auxPaymentForms.forEach(payForm => { 
                if(typeof auxPayments[payForm._id] === 'undefined') {
                    auxPayments[payForm._id] = {
                        amount:0,
                        key: payForm._id,
                        name: payForm.name
                    }
                }
            });

            let moneyForm = auxPaymentForms.filter(item => item['real_form'] === 'MONEY');

            if(moneyForm.length > 0) {
                moneyForm = moneyForm[0]

                auxPayments[moneyForm._id].amount -= changeValue;
            }

            let aux = [...Object.values(auxPayments)];
            aux.sort(function(a,b) {
                return ('' + a.name).localeCompare(b.name);
            });

            setPayments(aux)
    
        } catch (error) {
            console.log('iterateRecords error: ', error);
        }
    }

    return (
        <Row gutter={24}>
            <Col span={24}>
                <table style={{width:'100%', textAlign:'left', border:'1px #DDD solid', fontSize:'16px', padding:'2px !important'}} border="1px">
                    <thead>
                        <tr>
                            <th>Forma de pagamento</th>
                            <th style={{textAlign:'right'}}>Valor apurado (R$)</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            payments.map((payment) => {
                                return <tr style={{border:'1px #DDD solid', padding: '2px !important'}} key={payment.key}>
                                    <td>{payment.name}</td>
                                    <td style={{textAlign:'right'}}>{formatMoney(payment.amount+'')}</td>
                                </tr>
                            })
                        }
                    </tbody>
                </table>
            </Col>
        </Row>
    )
}